<template>
  <div class="repair-complaint-container">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="bg-white index-1-left-item">
          <div class="index-title">
            <span>房间状态统计</span>
          </div>
          <div id="complaintCount" style="height: 250px"></div>
          <!-- 状态明细展示区域 -->
          <div class="flex justify-between text-center stats-container">
            <div
              v-for="(item, key) in complaintStateDetail"
              :key="key"
              class="state-item"
            >
              <div class="index-bottom-number">
                {{ Number(item.count).toFixed(2) }}
              </div>
              <div class="index-bottom-number-desc">
                {{ item.name }}
              </div>
            </div>
            <div
              v-if="Object.keys(complaintStateDetail).length === 0"
              class="no-data"
            >
              {{ $t("propertyIndex.noData") }}
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "IndexRepairComplaint",
  props: {
    roomStateMap: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    complaintData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      indexRepairComplaintInfo: {
        allCount: 0,
        waitCount: 0,
        doingCount: 0,
        finishCount: 0,
        allComplaintCount: 0,
        waitComplaintCount: 0,
        finishComplaintCount: 0,
        complaintStateDetail: {},
        complaintBuildingDetail: {},
        buildingChartData: [],
      },
      repairChart: null,
      complaintChart: null,
      stateColors: {
        租赁中: "#01C36D",
        未销售: "#4B7AF0",
        已交房: "#FF7D00",
        未入住: "#F53F3F",
        已装修: "#86909C",
        已售: "#722ED1",
        空置中: "#EB0AA4",
        装修中: "#FF5722",
        借用中: "#FAAD14",
        免租期: "#0FC6C2",
        未知状态: "#86909C",
      },
      isDataLoaded: false,
    };
  },
  computed: {
    repairStats() {
      return [
        { label: "allRepair", value: this.indexRepairComplaintInfo.allCount },
        {
          label: "toBeDispatched",
          value: this.indexRepairComplaintInfo.waitCount,
        },
        {
          label: "processing",
          value: this.indexRepairComplaintInfo.doingCount,
        },
        {
          label: "processed",
          value: this.indexRepairComplaintInfo.finishCount,
        },
      ];
    },
    complaintStateDetail() {
      return this.indexRepairComplaintInfo.complaintStateDetail;
    },
  },
  watch: {
    complaintData: {
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          console.log("从父组件接收最新维修数据:", newVal);
          this.processRepairData(newVal);
        }
      },
      immediate: true,
    },
    roomStateMap: {
      handler(newVal) {
        console.log("从父组件接收最新状态映射:", newVal);
        if (this.isDataLoaded) {
          this.processFjzttjData(this.complaintData.fjzttj || {});
        }
      },
      immediate: true,
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    this.repairChart && this.repairChart.dispose();
    this.complaintChart && this.complaintChart.dispose();
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    processRepairData(repairData) {
      try {
        const fjzttj = repairData.fjzttj || {};
        this.processFjzttjData(fjzttj);
        Object.assign(this.indexRepairComplaintInfo, {
          allCount: repairData.allCount || 0,
          waitCount: repairData.waitCount || 0,
          doingCount: repairData.doingCount || 0,
          finishCount: repairData.finishCount || 0,
          allComplaintCount: repairData.allComplaintCount || 0,
          waitComplaintCount: repairData.waitComplaintCount || 0,
          finishComplaintCount: repairData.finishComplaintCount || 0,
        });
        this.isDataLoaded = true;
      } catch (error) {
        console.error("处理维修数据失败:", error);
      }
    },

    handleResize() {
      this.repairChart && this.repairChart.resize();
      this.complaintChart && this.complaintChart.resize();
    },

    sortBuildingKeys(keys) {
      const WEIGHT = {
        MAIN: 0, // 纯数字 4
        BEI: 1, // 4北
        NAN: 2, // 4南
        DASH: 3, // 6-、7-、9-1楼
        OTHER: 99,
      };

      // 解析每一个楼栋字符串，返回排序权重对象
      const parseItem = (str) => {
        // 场景1：A/B开头字母楼栋 A1 B10
        if (/^[AB]/.test(str)) {
          const letter = str[0];
          const numStr = str.replace(/^[AB]/, "");
          const num = parseInt(numStr, 10) || 0;
          return {
            group: 0, // 字母组整体排在最前面
            letter,
            num,
            mainNum: 0,
            suffixWeight: 0,
            subNum: 0,
            raw: str,
          };
        }

        // 场景2：纯数字楼栋 1、4、4北、9-1楼、6-
        let matchMain = str.match(/^(\d+)/);
        let mainNum = matchMain ? parseInt(matchMain[1], 10) : 999;
        let suffix = matchMain ? str.slice(matchMain[1].length) : str;

        let suffixWeight = WEIGHT.OTHER;
        let subNum = 0;

        if (suffix === "") {
          suffixWeight = WEIGHT.MAIN;
        } else if (suffix.startsWith("北")) {
          suffixWeight = WEIGHT.BEI;
        } else if (suffix.startsWith("南")) {
          suffixWeight = WEIGHT.NAN;
        } else if (suffix.includes("-")) {
          suffixWeight = WEIGHT.DASH;
          let subMatch = suffix.match(/-(\d+)/);
          subNum = subMatch ? parseInt(subMatch[1], 10) : 0;
        }

        return {
          group: 1, // 纯数组楼栋放第二组
          letter: "",
          num: 0,
          mainNum,
          suffixWeight,
          subNum,
          raw: str,
        };
      };

      return [...keys].sort((a, b) => {
        const aObj = parseItem(a);
        const bObj = parseItem(b);

        // 第一优先级：字母组(A/B)全部排在数字组前面
        if (aObj.group !== bObj.group) {
          return aObj.group - bObj.group;
        }

        // ========== 字母组内部排序 A1,A2,A3,A4,B1,B2...B10 ==========
        if (aObj.group === 0) {
          if (aObj.letter !== bObj.letter) {
            return aObj.letter.localeCompare(bObj.letter);
          }
          return aObj.num - bObj.num;
        }

        // ========== 纯数字楼栋内部排序 ==========
        // 1.先按主楼号 1,2,3,4,5,6,7,8,9...18
        if (aObj.mainNum !== bObj.mainNum) {
          return aObj.mainNum - bObj.mainNum;
        }
        // 2.同主楼号下顺序：主楼本身 → 北 → 南 → 带横杠后缀
        if (aObj.suffixWeight !== bObj.suffixWeight) {
          return aObj.suffixWeight - bObj.suffixWeight;
        }
        // 3.9-1楼、9-2楼 按横杠后面数字排序
        if (aObj.suffixWeight === WEIGHT.DASH) {
          return aObj.subNum - bObj.subNum;
        }

        // 兜底按原始字符串中文排序
        return aObj.raw.localeCompare(bObj.raw, "zh-CN");
      });
    },

    processFjzttjData(fjzttj) {
      let allComplaintCount = 0;
      let waitComplaintCount = 0;
      let finishComplaintCount = 0;
      const complaintBuildingDetail = {};
      const complaintStateDetail = {};
      const buildingChartData = [];

      if (typeof fjzttj !== "object" || fjzttj === null) {
        console.warn("fjzttj数据格式不正确，已初始化为空");
        this.updateComplaintData({
          allComplaintCount,
          waitComplaintCount,
          finishComplaintCount,
          complaintBuildingDetail,
          complaintStateDetail,
          buildingChartData,
        });
        return;
      }

      // 获取所有楼栋key + 执行修正排序
      const originBuildingKeys = Object.keys(fjzttj);
      const sortedBuildingList = this.sortBuildingKeys(originBuildingKeys);
      console.log("排序后的楼栋列表：", sortedBuildingList);
      sortedBuildingList.forEach((buildingKey) => {
        const stateObj = fjzttj[buildingKey];
        if (!stateObj) {
          buildingChartData.push({
            buildingName: buildingKey,
            rented: 0,
            empty: 0,
            total: 0,
            rate: "0.00",
          });
          return;
        }

        complaintBuildingDetail[buildingKey] = {};
        let buildingRented = parseFloat(
          Number(stateObj["2001"] || 0).toFixed(2),
        );
        let buildingEmpty = parseFloat(
          Number(stateObj["2008"] || 0).toFixed(2),
        );
        let buildingTotal = parseFloat(
          (buildingRented + buildingEmpty).toFixed(2),
        );

        Object.keys(stateObj).forEach((stateKey) => {
          const rawVal = Number(stateObj[stateKey]) || 0;
          const count = parseFloat(rawVal.toFixed(2));
          const stateName =
            this.roomStateMap[stateKey] || `未知状态(${stateKey})`;
          allComplaintCount = parseFloat(
            (allComplaintCount + count).toFixed(2),
          );

          const pendingStates = ["2002", "2004", "2008"];
          const completedStates = [
            "2001",
            "2003",
            "2005",
            "2006",
            "2007",
            "2009",
            "2010",
            "2011",
          ];
          if (pendingStates.includes(stateKey)) {
            waitComplaintCount = parseFloat(
              (waitComplaintCount + count).toFixed(2),
            );
          } else if (completedStates.includes(stateKey)) {
            finishComplaintCount = parseFloat(
              (finishComplaintCount + count).toFixed(2),
            );
          }

          complaintBuildingDetail[buildingKey][stateName] =
            (complaintBuildingDetail[buildingKey][stateName] || 0) + count;

          if (complaintStateDetail[stateKey]) {
            complaintStateDetail[stateKey].count = parseFloat(
              (complaintStateDetail[stateKey].count + count).toFixed(2),
            );
          } else {
            complaintStateDetail[stateKey] = {
              name: stateName,
              count: count,
            };
          }
        });

        let rate = "0.00";
        if (buildingTotal > 0) {
          rate = ((buildingRented / buildingTotal) * 100).toFixed(2);
        }
        buildingChartData.push({
          buildingName: buildingKey,
          rented: buildingRented,
          empty: buildingEmpty,
          total: buildingTotal,
          rate: rate,
        });
      });

      this.updateComplaintData({
        allComplaintCount,
        waitComplaintCount,
        finishComplaintCount,
        complaintBuildingDetail,
        complaintStateDetail,
        buildingChartData,
      });
    },

    updateComplaintData(data) {
      this.indexRepairComplaintInfo = {
        ...this.indexRepairComplaintInfo,
        ...data,
      };

      console.log(
        "更新后的状态明细数据:",
        this.indexRepairComplaintInfo.complaintStateDetail,
      );

      this.$nextTick(() => {
        this.initComplaintChart();
        this.initRepairChart();
      });
    },

    initRepairChart() {
      const dom = document.getElementById("repairCount");
      if (!dom) return;

      this.repairChart && this.repairChart.dispose();
      this.repairChart = echarts.init(dom);

      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)",
        },
        legend: {
          orient: "horizontal",
          bottom: 0,
          textStyle: { fontSize: 12 },
        },
        series: [
          {
            name: "费用类型",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 4,
              borderColor: "#fff",
              borderWidth: 2,
            },
            label: {
              show: false,
              position: "center",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 16,
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              {
                value: this.indexRepairComplaintInfo.waitCount,
                name: this.$t("propertyIndex.toBeDispatched"),
              },
              {
                value: this.indexRepairComplaintInfo.doingCount,
                name: this.$t("propertyIndex.processing"),
              },
              {
                value: this.indexRepairComplaintInfo.finishCount,
                name: this.$t("propertyIndex.processed"),
              },
            ],
          },
        ],
      };

      this.repairChart.setOption(option);
    },

    initComplaintChart() {
      const dom = document.getElementById("complaintCount");
      if (!dom) return;

      this.complaintChart && this.complaintChart.dispose();
      this.complaintChart = echarts.init(dom);

      const chartData = this.indexRepairComplaintInfo.buildingChartData;
      const xData = chartData.map((item) => `${item.buildingName}栋`);
      const rentedData = chartData.map((item) => item.rented);
      const emptyData = chartData.map((item) => item.empty);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
          formatter: function (params) {
            const idx = params[0].dataIndex;
            const row = chartData[idx];
            return `
              <div>${row.buildingName}栋</div>
              总面积：${row.total.toFixed(2)}<br/>
              已租赁面积：${row.rented.toFixed(2)}<br/>
              未租赁面积：${row.empty.toFixed(2)}<br/>
              去化率：${row.rate}%
            `;
          },
        },
        legend: {
          data: ["已租赁面积", "未租赁面积"],
          top: "2%",
          left: "center",
          textStyle: { fontSize: 12 },
        },
        grid: {
          left: "3%",
          top: "12%",
          right: "4%",
          bottom: "18%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: xData,
          axisLabel: {
            fontSize: 11,
            rotate: 35,
          },
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        series: [
          {
            name: "未租赁面积",
            type: "bar",
            stack: "total",
            data: emptyData,
            itemStyle: {
              color: "#EB0AA4",
            },
          },
          {
            name: "已租赁面积",
            type: "bar",
            stack: "total",
            data: rentedData,
            barWidth: 22,
            itemStyle: {
              color: "#01C36D",
            },
          },
        ],
      };

      this.complaintChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.index-1-left-item {
  background: #fff;
  border-radius: 4px;
  padding: 15px;

  .index-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
    color: #333;
  }

  .stats-container {
    padding-top: 15px;
    border-top: 1px solid #eee;
    display: flex;
    flex-wrap: wrap;

    .state-item {
      min-width: 80px;
      margin: 0 5px 10px;
    }

    .index-bottom-number {
      font-size: 20px;
      font-weight: bold;
      color: #333;
    }

    .index-bottom-number-desc {
      font-size: 12px;
      color: #999;
      margin-top: 5px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .no-data {
      color: #999;
      padding: 10px;
      width: 100%;
    }
  }
}
</style>
